module.exports = __webpack_public_path__ + "static/media/light-theme-utilization.69fe630f.svg";